import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

const STORAGE_KEY = "docuconvert_session_id";
const PING_INTERVAL_MS = 30000;

function getOrCreateSessionId() {
  let id = sessionStorage.getItem(STORAGE_KEY);
  if (!id) {
    id = "sess_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(STORAGE_KEY, id);
  }
  return id;
}

/**
 * Mounts a tiny client that pings /api/analytics/heartbeat every 30s with the
 * current path. Works for anonymous and logged-in users alike.
 */
export default function AnalyticsHeartbeat() {
  const location = useLocation();
  const timerRef = useRef(null);

  useEffect(() => {
    const sid = getOrCreateSessionId();
    const ping = () => {
      api.post("/analytics/heartbeat", {
        session_id: sid,
        path: location.pathname || "/",
      }).catch(() => {});
    };
    ping();
    timerRef.current = setInterval(ping, PING_INTERVAL_MS);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [location.pathname]);

  return null;
}
